const path =
  (obj) =>
  (...nodes) => {
    let val = obj;

    let i = 0;
    while (i < nodes.length) {
      if (val == null) {
        return val;
      }
      if (Array.isArray(nodes[i])) {
        val = val[nodes[i][0]];
      } else {
        val = val[nodes[i]];
      }

      i += 1;
    }
    return val;
  };

module.exports = path;
